import React, { useState, useEffect } from "react";
import styled from "styled-components";

const Container = styled.div`
    margin-top: 35px;
`;

const ImageGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 20vw);
    grid-gap: 5px;
    row-gap: 20px;
    justify-items: center;

    @media screen and (max-width: 1025px) {
        grid-template-columns: repeat(3, 25vw);
    }

    @media (max-width: 768px) {
        display: none;
    }

    display: none;
`;

const ImageCarousel = styled.div`
    /* display: none; */

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
`;

const Buttons = styled.div`
    width: 60vw;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    gap: 30px;
    margin: 50px 0 0 0;
`;

const CarouselButton = styled.button`
    /* @media (max-width: 768px) { */
    background-color: transparent;
    border-radius: 50px;
    border: 1px solid #000;
    width: 50px;
    height: 50px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    /* } */
`;

const CarouselContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    transition: transform 0.3s ease-in-out;

    @media screen and (min-width: 1025px) {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        justify-content: center;
        transition: transform 0.3s ease-in-out;
    }
`;

const ImageContainer = styled.div`
    width: 300px;
    height: 70px;
    position: relative;
`;

const Image = styled.img`
    position: absolute;
    margin-top: 10px;
    width: ${({ size }) => size};
    height: auto;
    /* max-width: 200px; */
    top: 0;
    left: 0;
`;

const ImageDesktop = styled.img`
    position: absolute;
    width: ${({ size }) => size};
    height: auto;
    height: 70px;

    @media screen and (max-width: 1025px) {
        width: 100%;
        height: auto;
        max-height: 70px;
    }
`;

const ArrowIcon = styled.img`
    width: 12px;
    rotate: ${({ iconRotate }) => (iconRotate ? "180deg" : "0deg")};
`;

const LinkClick = styled.a``;

const PagesIndicator = styled.div`
    text-align: end;
    /* padding-right: 60px; */
    color: #000;

    h4 {
        font-size: 18px;
        font-family: "Open Sans", sans-serif !important;
    }
`;

const LogosResponsiveCarousel = ({ logosLink }) => {
    const [start, setStart] = useState(0);
    const [end, setEnd] = useState(5);
    const [interval, setInterval] = useState(5);

    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);

    const handleNext = () => {
        if (currentPage + 1 <= totalPages) {
            setStart(start + interval);
            setEnd(end + interval);
            setCurrentPage(currentPage + 1);
        } else {
            setStart(0);
            setEnd(interval);
            setCurrentPage(1);
        }
    };

    const handlePrev = () => {
        if (currentPage - 1 > 0) {
            setStart(start - interval);
            setEnd(end - interval);
            setCurrentPage(currentPage - 1);
        } else {
            setStart(0);
            setEnd(interval);
            setCurrentPage(1);
        }
    };

    useEffect(() => {
        // console.log(logosLink);

        if (window.innerWidth <= 768) {
            setEnd(6);
            setInterval(6);
            setTotalPages(Math.ceil(logosLink.length / 6));
        } else {
            setEnd(12);
            setInterval(12);
            setTotalPages(Math.ceil(logosLink.length / 12));
        }
    }, []);

    return (
        <Container>
            <ImageGrid>
                {logosLink.map((current, index) => (
                    <ImageContainer key={index}>
                        <LinkClick
                            key={index}
                            href={current.link}
                            target="_blank"
                            style={
                                current.link !== ""
                                    ? null
                                    : { pointerEvents: "none" }
                            }
                        >
                            <ImageDesktop
                                size={
                                    current.image === "Traveler"
                                        ? "130%"
                                        : "100%"
                                }
                                src={current.image}
                                alt={`img-${index}`}
                            />
                        </LinkClick>
                    </ImageContainer>
                ))}
            </ImageGrid>

            <ImageCarousel>
                <CarouselContent>
                    {logosLink.slice(start, end).map((current, index) => (
                        <ImageContainer key={index}>
                            <LinkClick
                                key={index}
                                href={current.link}
                                target="_blank"
                            >
                                <Image
                                    size={
                                        current.link.includes("traveler")
                                            ? "110%"
                                            : "100%"
                                    }
                                    src={current.image}
                                    alt={`img-${index}`}
                                />
                            </LinkClick>
                        </ImageContainer>
                    ))}
                </CarouselContent>

                <Buttons>
                    <CarouselButton onClick={handlePrev}>
                        <ArrowIcon
                            src="/images/homepage/icons/arrow-line-bk.svg"
                            alt="arrow left"
                        />
                    </CarouselButton>
                    <PagesIndicator>
                        <h4>
                            <b>{currentPage}</b>/{totalPages}
                        </h4>
                    </PagesIndicator>
                    <CarouselButton onClick={handleNext}>
                        <ArrowIcon
                            src="/images/homepage/icons/arrow-line-bk.svg"
                            alt="arrow right"
                            iconRotate
                        />
                    </CarouselButton>
                </Buttons>
            </ImageCarousel>
        </Container>
    );
};

export default LogosResponsiveCarousel;
